module.exports = __webpack_public_path__ + "img/feedback-correct.b3c97583.png";